import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFullScreen = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M9.5 15.9 6.4 19H9v2H3v-6h2v2.6l3.1-3.1zm9.5 1.7V15h2v6h-6v-2h2.6l-3.1-3.1 1.4-1.4zM9 5H6.4l3.1 3.1-1.4 1.4L5 6.4V9H3V3h6zm12 4h-2V6.4l-3.1 3.1-1.4-1.4L17.6 5H15V3h6z" })
});
export default SvgFullScreen;
